import { SxProps, Theme } from "@mui/material/styles";

export const MprcInputStyles: Record<string, SxProps<Theme> | undefined> = {
    filter: {
        borderBottomStyle: "solid",
        borderBottomWidth: 1,
        borderColor: "warning.main",
        color: "warning.main",
        "& input": {
            color: "warning.main"
        },
        "& .MuiInputBase-root": {
            borderBottomStyle: "solid",
            borderBottomWidth: 1,
            borderColor: "warning.main",
        },
        "& .MuiInputBase-root:before": {
            borderBottomStyle: "solid",
            borderBottomWidth: 1,
            borderColor: "warning.main",
        },
        "& .MuiInputBase-root:after": {
            borderBottomStyle: "solid",
            borderBottomWidth: 1,
            borderColor: "warning.main",
        },
        "& .MuiInput-root:hover:not(.Mui-disabled, .Mui-error):before": {
            borderBottomStyle: "solid",
            borderBottomWidth: 1,
            borderColor: "warning.dark",
        },
        "& .MuiAutocomplete-popupIndicator": {
            color: "warning.main"
        }
    },
};
